// src/pages/SingleListingGenerator/index.js
import SingleListingGeneratorPage from './SingleListingGeneratorPage';

export default SingleListingGeneratorPage;